import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { Text } from '../../'
export class PaperHeadline extends React.PureComponent {
  static propTypes = {
    children: PropTypes.any,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  render() {
    const { children, id, className, style, refProp } = this.props

    return (
      <div
        id={id}
        className={cn('ui-paper__headline', className)}
        style={style}
        ref={refProp}
      >
        <Text type={Text.Types.headline}>{children}</Text>
      </div>
    )
  }
}
